import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[12px] font-semibold',
  {
    variants: {
      tone: {
        neutral: 'bg-fill text-muted',
        accent: 'bg-accent-soft text-accent-strong',
        ok: 'bg-ok/12 text-ok',
        warn: 'bg-warn/12 text-warn',
        bad: 'bg-bad/12 text-bad',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;
export const Badge = ({ className, tone, ...p }: BadgeProps) => (
  <span className={cn(badgeVariants({ tone }), className)} {...p} />
);
